import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {selectors} from './connectors';
import classNames from 'classnames';
import {getViewName} from '~/utils/catalog';
import {ID_VIEW_MAP} from '~/constants/ProductConstants';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {Dots} from '~/components/Dots';
import {metrics} from '~/vendor/metrics';
import includes from 'lodash/includes';
import size from 'lodash/size';
import './ColorCount.scss';

const renderColorCount = props => {
  const {designColors, fullColorViews} = props;

  return Object.keys(designColors).map(viewId => {
    return (
      <div className="color-per-view" key={viewId}>
        {isFullColor(fullColorViews, viewId)
          ? renderColorWheel(props, viewId)
          : renderColorDots(props, viewId)}
      </div>
    );
  });
};

const renderColorDots = (props, viewId) => {
  const {designColors} = props;
  const viewColors = designColors[viewId];

  return (
    <>
      <Dots colors={viewColors} />
      <span className="colors-view-text">{getViewLabel(props, viewId)}</span>
    </>
  );
};

const renderColorWheel = (props, viewId) => {
  const {inlineSvg, classnames} = props;

  return (
    <>
      <div className="icon-with-text">
        <div
          className={classNames('icon-wrapper full-color-icon', classnames)}
          dangerouslySetInnerHTML={renderInlineSvg(inlineSvg)}
        />
        {getViewLabel(props, viewId)}
      </div>
    </>
  );
};

const getViewLabel = (props, viewId) => {
  const {designColors, fullColorViews} = props;
  const fullColor = isFullColor(fullColorViews, viewId);
  const singlePrintArea = size(designColors) === 1;
  const colorCount = designColors[viewId].length;
  const colorLabel = fullColor ? 'Full color' : `${colorCount}`;
  const viewLabel = getViewName(ID_VIEW_MAP[viewId], false).toLowerCase();

  if (fullColor && singlePrintArea) {
    return colorLabel;
  }

  if (singlePrintArea) {
    return `${colorLabel} color${colorCount === 1 ? '' : 's'}`;
  }

  return `${colorLabel} ${viewLabel}`;
};

const isFullColor = (fullColorViews, viewId) => fullColorViews[viewId];

const fireTag = () => {
  metrics.fireEvent('real time pricing', 'color pills clicked');
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const ColorCount = props => {
  const {fullColorViews, isBlank, viewColorCount} = props;

  if (isBlank) {
    return null;
  }

  const hasColors = includes(fullColorViews, true) || viewColorCount > 0;

  if (!hasColors) {
    return null;
  }

  return (
    <div className="ndx-ColorCount">
      <div className="ndx-chip">
        <div
          className="ndx-chip-body"
          onClick={props.fireTags ? fireTag : undefined}>
          {renderColorCount(props)}
        </div>
      </div>
    </div>
  );
};

ColorCount.displayName = 'ColorCount';

const propTypes = {
  designColors: PropTypes.object,
  fireTags: PropTypes.bool,
  fullColorViews: PropTypes.object,
  isBlank: PropTypes.bool,
  viewColorCount: PropTypes.number
};

ColorCount.propTypes = propTypes;

export default connect(selectors, null)(ColorCount);
